export default "__VITE_ASSET__Ci_YyJIb__"